import { OptionItem } from 'matchmaking/models';

// title here represents keys used in the translation service
export const INVESTMENT_GOALS: OptionItem[] = [
    {
        id: 1,
        title: 'mainGoalQuestion1',
        description: 'mainGoalQuestionDescription1'
    },
    {
        id: 2,
        title: 'mainGoalQuestion2',
        description: 'mainGoalQuestionDescription2'
    },
    {
        id: 3,
        title: 'mainGoalQuestion3',
        description: 'mainGoalQuestionDescription3'
    }
];

export const INVESTMENT_LEVELS: OptionItem[] = [
    { id: 1, title: 'investmentQuestion1' },
    { id: 2, title: 'investmentQuestion2' },
    { id: 3, title: 'investmentQuestion3' }
];

export const INVESTMENT_TIMELINE: OptionItem[] = [
    { id: 1, title: 'timelineQuestion1', salesforceMappingValue: '3 months' },
    { id: 2, title: 'timelineQuestion2', salesforceMappingValue: '3 months' },
    { id: 3, title: 'timelineQuestion3', salesforceMappingValue: '6 months' },
    { id: 4, title: 'timelineQuestion4', salesforceMappingValue: 'unknown' }
];
